import React from 'react';

const Loader = () => (
    <div className="flex flex-col justify-center items-center p-8">
        <div className="gaming-loader"></div>
        <div className="mt-4 gaming-text-primary font-medium text-sm uppercase tracking-wider">
            กำลังโหลด...
        </div>
    </div>
);

export default Loader;
